import InsuranceContextsSelector from './InsuranceContextsSelector';

export default InsuranceContextsSelector;
